/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_Analytics_DescInputs */

const en_privacy_section_2_item_analytics_desc = /** @type {(inputs: Privacy_Section_2_Item_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`page views, session duration, device type, browser information, and approximate location via Google Analytics (through Google Tag Manager)`)
};

const lv_privacy_section_2_item_analytics_desc = /** @type {(inputs: Privacy_Section_2_Item_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lapu skatījumi, sesiju ilgums, ierīces tips, pārlūka informācija un aptuvena atrašanās vieta caur Google Analytics (caur Google Tag Manager)`)
};

/**
* | output |
* | --- |
* | "page views, session duration, device type, browser information, and approximate location via Google Analytics (through Google Tag Manager)" |
*
* @param {Privacy_Section_2_Item_Analytics_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_analytics_desc = /** @type {((inputs?: Privacy_Section_2_Item_Analytics_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_Analytics_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_analytics_desc(inputs)
	return en_privacy_section_2_item_analytics_desc(inputs)
});